import { Box, Flex, Heading, Text, Input, Collapse } from "@chakra-ui/react";
import SelectionRadio from "./SelectionRadio";

function AddressInput(props: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}) {
  const { value, onChange, placeholder } = props;
  return (
    <Input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      bg="#FFFFFF"
      border="1px solid #E6ECF3"
      borderRadius="12px"
      fontSize="14px"
      color="#0B0E10"
      _hover={{}}
      _placeholder={{ color: "#505E70" }}
      _focus={{ borderColor: "#3A7BFF", boxShadow: "none" }}
      onClick={(e) => e.stopPropagation()}
      h="48px"
    />
  );
}

export default function MailedHardCopyOptionRow(props: {
  title: string;
  description: string;
  price: string;
  badgeText?: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  recipientName: string;
  streetAddress: string;
  city: string;
  zipCode: string;
  state: string;
  country: string;
  onFieldChange: (field: string, value: string) => void;
}) {
  const {
    title,
    description,
    price,
    badgeText,
    checked,
    onChange,
    recipientName,
    streetAddress,
    city,
    zipCode,
    state,
    country,
    onFieldChange,
  } = props;

  return (
    <Box
      borderRadius="12px"
      border={`1px solid ${checked ? "#3A7BFF" : "#E6ECF3"}`}
      bg={checked ? "#F5F9FF" : "#FFFFFF"}
      p="16px"
      cursor="pointer"
    >
      <Flex
        alignItems="flex-start"
        gap="16px"
        onClick={() => onChange(!checked)}
      >
        <SelectionRadio checked={checked} />

        <Box flex="1" minW="0">
          <Flex
            alignItems="center"
            gap="8px"
            minW="0"
            flexWrap="wrap"
            rowGap="6px"
          >
            <Heading
              fontSize="18px"
              fontWeight="600"
              color="#0B0E10"
              noOfLines={1}
            >
              {title}
            </Heading>
            {badgeText ? (
              <Box
                px="10px"
                py="3px"
                maxW="114px"
                fontStyle="Semibold"
                borderRadius="4px"
                bg="#D6EFE1"
                color="#2B9057"
                fontSize="12px"
                fontWeight="600"
                whiteSpace="normal"
                wordBreak="break-word"
              >
                {badgeText}
              </Box>
            ) : null}
          </Flex>
          <Text
            mt="6px"
            fontSize="14px"
            fontWeight="400"
            color="#505E70"
            lineHeight="160%"
            maxW="369px"
          >
            {description}
          </Text>
        </Box>
        <Text
          fontSize="20px"
          fontWeight="600"
          color="#0B0E10"
          whiteSpace="nowrap"
        >
          {price}
        </Text>
      </Flex>

      <Collapse in={checked} animateOpacity>
        <Box mt="16px" pb="16px" borderTop="1px solid #D9D9D9" />
        <Box>
          <Flex direction="column" gap="16px">
            <AddressInput
              value={recipientName}
              onChange={(v) => onFieldChange("mailedHardCopyRecipientName", v)}
              placeholder="Recipient Name"
            />
            <AddressInput
              value={streetAddress}
              onChange={(v) => onFieldChange("mailedHardCopyStreetAddress", v)}
              placeholder="Street Address"
            />
            <Flex gap={{ base: "16px", md: "12px" }} flexWrap="wrap">
              <Box flex="1" minW={{ base: "100%", md: "140px" }}>
                <AddressInput
                  value={city}
                  onChange={(v) => onFieldChange("mailedHardCopyCity", v)}
                  placeholder="City"
                />
              </Box>
              <Box flex="1" minW={{ base: "100%", md: "140px" }}>
                <Input
                  value={zipCode}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "").slice(0, 5);
                    onFieldChange("mailedHardCopyZipCode", val);
                  }}
                  placeholder="Zip Code"
                  bg="#FFFFFF"
                  border="1px solid #E6ECF3"
                  borderRadius="12px"
                  fontSize="14px"
                  color="#0B0E10"
                  _hover={{}}
                  _placeholder={{ color: "#505E70" }}
                  _focus={{ borderColor: "#3A7BFF", boxShadow: "none" }}
                  onClick={(e) => e.stopPropagation()}
                  h="48px"
                  maxLength={5}
                  inputMode="numeric"
                />
              </Box>
            </Flex>
            <AddressInput
              value={state}
              onChange={(v) => onFieldChange("mailedHardCopyState", v)}
              placeholder="State"
            />
            <AddressInput
              value={country}
              onChange={(v) => onFieldChange("mailedHardCopyCountry", v)}
              placeholder="Country"
            />
          </Flex>
        </Box>
      </Collapse>
    </Box>
  );
}
